import { Button, Col, Form, Input, Modal, Result, Row, message } from "antd";
import { useUpdateEnumeratorProfile } from "api/enumerator/Profile/useUpdateProfile";
import React from "react";
import { storage } from "utils/storage";

type SettingFormProps = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  index: number | null;
};

const SettingForm: React.FC<SettingFormProps> = ({ isModalOpen, setIsModalOpen, index }) => {
  const [form] = Form.useForm();

  const updateProfileMutation = useUpdateEnumeratorProfile();

  const handleSubmit = async () => {
    const user = storage.getUserFromStorage();
    const values = await form.validateFields();

    if (user?.uid) {
      updateProfileMutation.mutate(
        { id: user.uid, enumerator: values },
        {
          onSuccess: () => {
            form.resetFields();
          },
        }
      );
    } else {
      message.error("User id not found");
    }
  };

  const getModalContent = () => {
    if (updateProfileMutation.isSuccess) {
      return (
        <>
          <Result
            status="success"
            title={
              index === 1
                ? "Congratulations ! You have successfully added email."
                : "Congratulations ! You have successfully added phone number."
            }
            subTitle="You cannot change the existing email or phone number settings but you can add one."
          />
        </>
      );
    } else {
      return (
        <Form form={form} layout="vertical" onFinish={handleSubmit} className="mt-8">
          <Row>
            <Col span={24}>
              {index === 3 && (
                <Form.Item
                  name="phoneNumber"
                  label="Phone Number"
                  rules={[
                    {
                      required: true,
                      message: "Phone number is required",
                    },
                  ]}
                >
                  <Input placeholder="eg. 9848442507" />
                </Form.Item>
              )}
            </Col>
            <Col span={24}>
              {index === 1 && (
                <Form.Item
                  name="email"
                  label="Email address"
                  rules={[
                    {
                      required: true,
                      message: "Email is required",
                    },
                    {
                      type: "email",
                      message: "Please enter valid email",
                    },
                  ]}
                >
                  <Input placeholder="eg. sajiloventures@gmail.com" />
                </Form.Item>
              )}
            </Col>
          </Row>
        </Form>
      );
    }
  };

  return (
    <>
      <Modal
        onCancel={() => setIsModalOpen(false)}
        title={
          index === 1 ? (
            <h5 className="text-xl md:text-xl font-semibold leading-tighter  mb-4 text-lightGrey">
              Add Email
            </h5>
          ) : (
            <h4 className="text-2xl md:text-2xl font-semibold text-lightGrey">Add Phone number</h4>
          )
        }
        open={isModalOpen}
        footer={
          updateProfileMutation.isSuccess
            ? [
                <Button
                  className="h-10 px-8 border border-1 border-border text-base bg-primary text-white border-none"
                  type="primary"
                  onClick={() => setIsModalOpen(false)}
                >
                  Go back
                </Button>,
              ]
            : [
                <Button
                  className="h-10 px-8 border border-1 border-border text-base"
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </Button>,
                <Button
                  className="h-10 px-8 border border-1 border-border text-base bg-primary text-white border-none"
                  onClick={handleSubmit}
                  type="primary"
                  loading={updateProfileMutation.isPending}
                >
                  Save Changes
                </Button>,
              ]
        }
      >
        {getModalContent()}
      </Modal>
    </>
  );
};

export default SettingForm;
